import { Domain, MappingLevel } from "./types";

export const isAllowRequiredForBooking = (params: {
  mappingLevel: MappingLevel;
  domain: Domain;
  isCredentialRequirementConfigurationEnabled: boolean;
}) => {
  const { mappingLevel, domain, isCredentialRequirementConfigurationEnabled } = params;
  if (domain !== Domain.HIRING) {
    return true;
  }

  return (
    (mappingLevel === MappingLevel.STATE && isCredentialRequirementConfigurationEnabled) ||
    mappingLevel === MappingLevel.HCF
  );
};
